// extracted by mini-css-extract-plugin
export var active = "_ec-7";
export var blink = "_ec-8";
export var dropDownSelector = "_ec-4";
export var dropDownWrapper = "_ec-3";
export var fakeCursor = "_ec-6";
export var fontSizeButton = "_ec-9";
export var formQuillEditor = "_ec-0";
export var pressed = "_ec-a";
export var qlBlank = "_ec-1";
export var textFormattingToolbar = "_ec-2";
export var textToolbarOption = "_ec-5";